import { LegacyRef, useEffect, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import Error from "../error";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import MoveInOut, { MoveOutData } from "../../stores/MoveInOutStore";
import ArrowDown from '../../assets/arrowDown.svg'; // Adjust the path according to your project structure

import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import MoveoutUpload from "./MoveoutUpload";
import moment from "moment";
import { NotifyError } from "../../utils/ShowError";
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  sewerageNumbers: Obj;
  sewerageRef: LegacyRef<HTMLSelectElement> | undefined;
  getDetails: () => Promise<boolean>;
  validateLoader: boolean;
  fileUpload: boolean;
  uploadDocs: (payload: any) => void;
  message?: string;
}

const PropertyDetails = ({
  sewerageNumbers,
  sewerageRef,
  getDetails,
  Next,
  validateLoader,
  fileUpload,
  uploadDocs,
  message,

}: Props) => {
  const [shown, setShown] = useState<boolean>(false);
  const [fileShown, setFileShown] = useState<boolean>(false);
  
  const [propertyDetails, setPropertyDetails] = useState<string>("");
  const [selectValue, setSelectValue] = useState<string>("0");
  // let propertyDetails = ''
  let temp = "";

  const handleValidate = async () => {

    setShown(false);
    if (await getDetails()) {
      setPropertyDetails(temp);
        setShown(true);
    }
    setFileShown(false);

  };
 
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectValue(event.target.value);
    setFileShown(true);
    setShown(false); // Hide shown content when select value changes
  };

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const handleFileUpload = (files: File[]) => {
    // const payload = {
    //   multiFileUpload: Object.values(files)
    // };
    const multiFileUpload = Object.values(files);
    // console.log("File upload triggered", multiFileUpload);
    const data = {
      accountId: MoveInOut.moveOutInfo.accountId,
      premiseId: MoveInOut.moveOutInfo.premiseId,
      platform: "Web"
    }
    const payload = {
      data: data,
      multiFileUpload: multiFileUpload,
      isFileUploadValid: true,
      invalidFileNames: [],
    };
    uploadDocs(payload);
    // console.log("File upload payload", payload);

  
  }
  useEffect(() => { 
    if (message && message.length > 0) {
      NotifyError(General?.codeLabels[message]?.label);
    } 
  },[message]);
  return (
    <>
      <TabContainer
        style={{
          gap: "0rem",
          display: "flex", flexDirection: "column",
          minHeight: "50vh",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <p
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                margin: "20px 0px",
              }}
            >
              {General?.codeLabels["cm_moveout_info"]?.label?General?.codeLabels["cm_moveout_info"]?.label:"Select the property to start your Move Out appliction"}
            </p>
            <Error id="validateMoveOutError" />
            <div style={{ display: "flex",flexDirection:General?.isLargeScreen?"row":"column", alignItems: "center", gap:General?.isLargeScreen?"1rem":"" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="sewerageNumber + select"
              >
                <Label
                  style={{
                    color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    // width:General?.isLargeScreen?"":""
                  }}
                >
                  {General?.codeLabels["cm_moveoutproperty"]?.label !== undefined
                    ? General?.codeLabels["cm_moveoutproperty"]?.label
                    : "Select Move Out Property"}
                  <select
                    value={selectValue}
                    ref={sewerageRef}
                    onChange={handleSelectChange}
                    defaultValue="select"
                    style={{
                      outline: "none",
                      width:General?.isLargeScreen? "259px":"95vw",
                      height: "55px",
                      padding: "16px 14px",
                      border: "1px solid "+General?.ColorAss,
                      paddingRight: "1rem",
                      color: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                      background: contrast?.contrastColor ? contrast?.contrastColor : "#edf4f6",
                    }}
                   
                  >
                    <option
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                      }}
                      value=""
                      disabled
                      selected
                      hidden
                    >
                      {" "}
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>

                    {sewerageNumbers.map((obj: Obj, index: number) => {
                      return (
                        <option
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                          }}
                          value={index}
                        >
                          {obj.key}
                        </option>
                      );
                    })}
                  </select>
                </Label>
              </div>
              <div className="button" style={{ marginTop:General?.isLargeScreen? "17px" :"0.5rem"}}>
                <ButtonSecondary
                  style={{
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    width:General?.isLargeScreen? "168px":"95vw",
                    height: "55px",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    border:"none"
                  }}
                  onClick={handleValidate}
                  disabled={validateLoader?true:false}
                >
                  {validateLoader?<Spinner width="30px" height="30px" />: General?.codeLabels["cm_validate"]?.label !== undefined
                    ? General?.codeLabels["cm_validate"]?.label
                    : "VALIDATE"}
                </ButtonSecondary>
              </div>
            </div>
            {fileUpload  && !fileShown &&(<MoveoutUpload onSubmit={async (files) => {handleFileUpload(files)}} submitLoader={false}/>)}
            {(shown && !fileUpload && message?.length === 0) &&(
              <div style={{marginTop:General?.isLargeScreen?'3rem':'3rem', width: "100%" }} >
                <h3
                  style={{
                    marginBottom: "0",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_propertydet"]?.label !== undefined
                    ? General?.codeLabels["cm_propertydet"]?.label
                    : "Property Details"}
                </h3>
                <p
                  style={{
                    marginTop: "0",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {sewerageNumbers[selectValue]?.value}
                </p>

                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    width:General?.isLargeScreen? "50%":"98%",
                    fontSize: `${General.accessibility.fontSize}rem`,
                  }}
                >
                  {General?.codeLabels["cm_moveout_date"]?.label?General?.codeLabels["cm_moveout_date"]?.label:"Move Out Date"}
                  <input
                    type="text"
                    disabled
                    defaultValue={ moment(MoveInOut.moveOutInfo.serviceTerminationDate)?.format('DD-MMM-YYYY')}
                    style={{ 
                      background: contrast?.contrastColor ? contrast?.contrastColor : "#e5eff2",
                      direction:'ltr',textAlign:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"right":"left", 
                      color: contrast?.contrastColor ? contrast?.contrastBackground : ColorAss}}
                  />
                </Label>

                <hr
                  style={{
                    width: "100%",
                    marginBottom: "40px",
                    marginTop: "20px",
                    fontSize: `${General.accessibility.fontSize}rem`,
                  }}
                />

                <ButtonSecondary
                  style={{
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                    width: General?.isLargeScreen?"20%":"98%",
                    fontSize: `${General.accessibility.fontSize}rem`,
                  }}
                  onClick={Next}
                >
                  {General?.codeLabels["cm_btncontinue"]?.label !== undefined
                    ? General?.codeLabels["cm_btncontinue"]?.label
                    : "Continue"}
                </ButtonSecondary>
              </div>
            )}
          </div>
        </div>
      </TabContainer>
    </>
  );
};

export default observer(PropertyDetails);
